export const lemonlightOrganizationId = '6746ebf6dc7e3c03db000000';

export const lemonlightEmergencyContacts = [
  {
    role: 'Emergency Contact #1',
    fullName: 'Hillary Freedman',
    phoneNumber: '(626) 353-8144',
  },
  {
    role: 'Emergency Contact #2',
    fullName: 'Joshua Kaufman',
    phoneNumber: '(214) 336-5674',
  },
] as const;

// This should be moved to the Organization model
export const getEmergencyContacts = (organizationId: string) => {
  switch (organizationId) {
    case lemonlightOrganizationId:
      return lemonlightEmergencyContacts;
    default:
      return [];
  }
};

export const playgroundDocument = 'PLAYGROUND_DOCUMENT';

export type EmergencyContactRole =
  (typeof lemonlightEmergencyContacts)[number]['role'];
